module ContentEditableDivAjaxSave
{
	const originalValueAttribute = "originalvalue";

	export function construct(): void {
		const expandoTextBoxes = $("div[contenteditable=true][data-columnid]");
		expandoTextBoxes.each((index, htmlElement) => {
			const element = $(htmlElement);
			element.data(originalValueAttribute, element.html());
		});
		expandoTextBoxes.blur(onDivChanged);
	}

	function onDivTypedInto(): void {
		
	}

	function onDivChanged(): void {
		const element = $(this);

		//If value hasn't changed, don't save.
    if (!getIfDivChanged(element))
		{
			return;
    }

    const value = element.html();
		element.data(originalValueAttribute, value);

		const columnid = String(element.data("columnid"));
		const rowid = getRowId(element);

		AjaxSave.updateDatabase(columnid, rowid, value);
	}

	function getRowId(element: JQuery<HTMLElement>): string
	{
		return AjaxSave.getRowId(element);
  }

  function getIfDivChanged(element: JQuery<HTMLElement>) {
    const currentValue = element.html();
    const previousValue = element.data(originalValueAttribute);
    return currentValue != previousValue;
  }
}